export class DashboardModel {
    Customer: CompanyKPIsCustomerCount[] = [];
    WorkOrder: CompanyKPIsWorkOrder[] = [];
    Technician: CompanyKPIsTechnicianPerf[] = [];
}
export class CompanyKPIsWorkOrder {
    ID: string
    TotalCalls: number
    WorkOrderStatus: string
    WorkOrderSubStatus: string
}
export class CompanyKPIsCustomerCount {
    CompanyId: string
    NewCustomerCount: number
    TotalCustomerCount: number
}
export class CompanyKPIsTechnicianPerf {
    AvgAmount: number
    BalanceDue: number
    TechnicianName: string
    ToatalAmount: number
}
export class WorkOrderDashboard {
    WorkOrderStatus: string = "";
    TotalCalls: number = 0;
    WorkOrderSubStatus: string = "";
    color: string = "";
}